import { GetPermissionsResponse } from '@eventmanager/types';

import { apiRoutes } from '../../config';
import http from './client';

export async function getPermissions(): Promise<GetPermissionsResponse> {
  const response = await http.get(apiRoutes.permissions);
  return response.data || null;
}
